<!-- <div class="card">
  <h5>Vertical</h5>
  <p-chart type="bar" [data]="basicData" [options]="basicOptions"></p-chart>
</div>

<div class="card">
  <h5>Horizontal</h5>
  <p-chart type="bar" [data]="basicData" [options]="horizontalOptions"></p-chart>
</div>

<div class="card">
  <h5>Multi Axis</h5>
  <p-chart type="bar" [data]="multiAxisData" [options]="multiAxisOptions"></p-chart>
</div>

<div class="card">
  <h5>Stacked</h5>
  <p-chart type="bar" [data]="stackedData" [options]="stackedOptions"></p-chart>
</div> -->
<!-- <div class="container">
 <div class="row">
  <div class="col-1"><app-sidebar [isExpanded]="sidebarExpanded" (toggleSidebar)="sidebarExpanded = !sidebarExpanded" ></app-sidebar></div>
  <div class="col-11"><router-outlet></router-outlet></div>


</div> 
</div> -->

<div class="layer"></div>
<!-- ! Body -->
<a class="skip-link sr-only" href="#skip-target">Skip to content</a>
<div class="page-flex">
  
  <!-- ! Sidebar -->
  <aside  [ngClass]="[display==false?'hidden':'']" class="sidebar">
    <div class="sidebar-start">
        <div class="sidebar-head">
            <a href="/" class="logo-wrapper" title="Home">
                <span class="sr-only">Home</span>
                <!-- <span class="icon logo" aria-hidden="true"></span> -->
                <div class="logo-text">
                    <span class="logo-title">Excursion </span>
                    <span class="logo-title">Tracking</span>
                </div>
            </a>
            <button (click)="chagesidebar()" [ngClass]="[display==false?'rotated':'']" class="sidebar-toggle transparent-btn " title="Menu" type="button">
                <span class="sr-only">Toggle menu</span>
                <span class="icon menu-toggle" aria-hidden="true"></span>
            </button>
        </div>
        <div class="sidebar-body">
          <ul class="sidebar-body-menu">
            <li *ngFor="let item of menuItem">
              <a [routerLink]="item.pagename" routerLinkActive="active"><span [ngClass]="item.icon" aria-hidden="true"></span>{{item.menudesc}}</a>
            </li>
          </ul>

            <!-- <ul class="sidebar-body-menu">
                <li>
                    <a [routerLink]="['/webqnex/dashboard']" routerLinkActive="active"><span class="icon home" aria-hidden="true"></span>Dashboard</a>
                </li>
                <li>
                    <a class="show-cat-btn" [routerLink]="['/webqnex/excursion']" routerLinkActive="active">
                        <span class="icon document" aria-hidden="true"></span>Excursion
                    </a>
                </li>
                <li>
                    <a class="show-cat-btn" [routerLink]="['/webqnex/daily_report']" routerLinkActive="active">
                        <span class="icon paper" aria-hidden="true"></span>Daily Reports
                    </a>
                </li>
                <li>
                    <a [routerLink]="['/webqnex/dashboard_setting']" routerLinkActive="active">
                        <i style="font-size: 22px;width: 24px;" class="icon pi pi-cog"></i>
                        Dashboard Settings
                    </a>
                </li>
            </ul> -->
            <!-- <span class="system-menu__title">system</span> -->
            <ul class="sidebar-body-menu">
                <li>
                    <!-- <a href="#"><span class="icon edit" aria-hidden="true"></span>Appearance</a> -->
                </li>
                <li>
                    <!-- <a class="show-cat-btn" href="##">
                        <span class="icon category" aria-hidden="true"></span>Extentions
                        <span class="category__btn transparent-btn" title="Open list">
                            <span class="sr-only">Open list</span>
                            <span class="icon arrow-down" aria-hidden="true"></span>
                        </span>
                    </a>
                    <ul class="cat-sub-menu">
                        <li>
                            <a href="#">Extentions-01</a>
                        </li>
                        <li>
                            <a href="#">Extentions-02</a>
                        </li>
                    </ul> -->
                </li>
                <li>
                    <!-- <a class="show-cat-btn" href="##">
                        <span class="icon user-3" aria-hidden="true"></span>Users
                        <span class="category__btn transparent-btn" title="Open list">
                            <span class="sr-only">Open list</span>
                            <span class="icon arrow-down" aria-hidden="true"></span>
                        </span>
                    </a> -->
                    <ul class="cat-sub-menu">
                        <li>
                            <a href="#">Users-01</a>
                        </li>
                        <li>
                            <a href="#">Users-02</a>
                        </li>
                    </ul>
                </li>
                <!-- <li>
                    <a href="##"><span class="icon setting" aria-hidden="true"></span>Settings</a>
                </li> -->
            </ul>
        </div>
    </div>
    <div class="sidebar-footer">
        <a (click)="logout()" class="sidebar-user">
            <span title="Logout" class="sidebar-user-img">
                <!-- <picture><source srcset="/ExcursionsUI/assets/img/avatar/avatar-illustrated-01.webp" type="image/webp">
                  <img src="/ExcursionsUI/assets/img/avatar/avatar-illustrated-01.png" alt="User name"></picture> -->
                  <picture><source srcset="{{this.srcsetwebp1}}" type="image/webp">
                    <img src="{{this.imgsrc1}}" alt="User name"></picture>
            </span>
            <!-- <div class="sidebar-user-info">
                <span class="sidebar-user__title">Jassa</span>
                <span class="sidebar-user__subtitle">Support manager</span>
            </div> -->
        </a>
        <span style="color: aliceblue;">{{username}}<span (click)="logout()" style="color: aliceblue;"> logout</span></span>

    </div>
</aside>
  <div class="main-wrapper">
    <!-- ! Main nav -->
    <nav class="main-nav--bg">
  <div style="display:none;" class="container main-nav">
    <div class="main-nav-start">
      <div class="search-wrapper">
        <i data-feather="search" aria-hidden="true"></i>
        <input type="text" placeholder="Enter keywords ..." required>
      </div>
    </div>
    <div class="main-nav-end">
      <button class="sidebar-toggle transparent-btn" title="Menu" type="button">
        <span class="sr-only">Toggle menu</span>
        <span class="icon menu-toggle--gray" aria-hidden="true"></span>
      </button>
      <div class="lang-switcher-wrapper">
        <button class="lang-switcher transparent-btn" type="button">
          EN
          <i data-feather="chevron-down" aria-hidden="true"></i>
        </button>
        <ul class="lang-menu dropdown">
          <li><a href="##">English</a></li>
          <li><a href="##">French</a></li>
          <li><a href="##">Uzbek</a></li>
        </ul>
      </div>
      <button class="theme-switcher gray-circle-btn" type="button" title="Switch theme">
        <span class="sr-only">Switch theme</span>
        <i class="sun-icon" data-feather="sun" aria-hidden="true"></i>
        <i class="moon-icon" data-feather="moon" aria-hidden="true"></i>
      </button>
      <div class="notification-wrapper">
        <button class="gray-circle-btn dropdown-btn" title="To messages" type="button">
          <span class="sr-only">To messages</span>
          <span class="icon notification active" aria-hidden="true"></span>
        </button>
        <ul class="users-item-dropdown notification-dropdown dropdown">
          <li>
            <a href="##">
              <div class="notification-dropdown-icon info">
                <i data-feather="check"></i>
              </div>
              <div class="notification-dropdown-text">
                <span class="notification-dropdown__title">System just updated</span>
                <span class="notification-dropdown__subtitle">The system has been successfully upgraded. Read more
                  here.</span>
              </div>
            </a>
          </li>
          <li>
            <a href="##">
              <div class="notification-dropdown-icon danger">
                <i data-feather="info" aria-hidden="true"></i>
              </div>
              <div class="notification-dropdown-text">
                <span class="notification-dropdown__title">The cache is full!</span>
                <span class="notification-dropdown__subtitle">Unnecessary caches take up a lot of memory space and
                  interfere ...</span>
              </div>
            </a>
          </li>
          <li>
            <a href="##">
              <div class="notification-dropdown-icon info">
                <i data-feather="check" aria-hidden="true"></i>
              </div>
              <div class="notification-dropdown-text">
                <span class="notification-dropdown__title">New Subscriber here!</span>
                <span class="notification-dropdown__subtitle">A new subscriber has subscribed.</span>
              </div>
            </a>
          </li>
          <li>
            <a class="link-to-page" href="##">Go to Notifications page</a>
          </li>
        </ul>
      </div>
      <div class="nav-user-wrapper">
        <button href="##" class="nav-user-btn dropdown-btn" title="My profile" type="button">
          <span class="sr-only">My profile</span>
          <span class="nav-user-img">
            <!-- <picture>
              <source srcset="/ExcursionsUI/assets/img/avatar/avatar-illustrated-02.webp" type="image/webp">
              <img src="/ExcursionsUI/assets/img/avatar/avatar-illustrated-02.png" alt="User name"></picture> -->
              <picture><source srcset="{{this.srcsetwebp2}}" type="image/webp">
                <img src="{{this.imgsrc2}}" alt="User name"></picture>
          </span>
        </button>
        <ul class="users-item-dropdown nav-user-dropdown dropdown">
          <li><a href="##">
              <i data-feather="user" aria-hidden="true"></i>
              <span>Profile</span>
            </a></li>
          <li><a href="##">
              <i data-feather="settings" aria-hidden="true"></i>
              <span>Account settings</span>
            </a></li>
          <li><a class="danger" href="##">
              <i data-feather="log-out" aria-hidden="true"></i>
              <span>Log out</span>
            </a></li>
        </ul>
      </div>
    </div>
  </div>
</nav>
    <!-- ! Main -->
    <router-outlet></router-outlet>
    
    <!-- ! Footer -->
    <!-- <footer class="footer">
  <div class="container footer--flex">
    <div class="footer-start">
      <p>2021 © Therichpost Dashboard - <a href="https://therichpost.com" target="_blank"
          rel="noopener noreferrer">therichpost.com</a></p>
    </div>
    <ul class="footer-end">
      <li><a href="##">About</a></li>
      <li><a href="##">Support</a></li>
      <li><a href="##">Puchase</a></li>
    </ul>
  </div>
</footer> -->
  </div>
</div>